module.exports = __webpack_public_path__ + "media/images/shared/suppliers/DAF-b3740218f111bde2d7d868a1c9025501.jpg";